/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiNotificationSetting, ApiUpsertNotificationSettingRequest, EnumNotificationModule } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of NotificationSettingsController.
 */
export class NotificationSettingsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /notification_settings:query
     */
    public query(): Promise<Result<ApiNotificationSetting[]>> {
        return this.http.get<Result<ApiNotificationSetting[]>>('/notification_settings:query');
    }

    /**
     * Calls PUT /notification_settings
     */
    public upsert(request: ApiUpsertNotificationSettingRequest): Promise<Result<ApiNotificationSetting>> {
        return this.http.put<Result<ApiNotificationSetting>, ApiUpsertNotificationSettingRequest>('/notification_settings', request);
    }

    /**
     * Calls DELETE /notification_settings
     */
    public reset(module: EnumNotificationModule | undefined): Promise<Result<number>> {
        const query = new URLSearchParams();
        if (module !== undefined) {
            query.set('module', `${module}`);
        }

        return this.http.delete<Result<number>>('/notification_settings', query);
    }
}
